import React from 'react'

const ButtonForProductDocuments = (
    {
        isEditProductPresentation,
        addDocProductToPresentation
    }
) => {
    return (
        <>
            {
                isEditProductPresentation ?
                    null
                    :
                    <button onClick={(e) => addDocProductToPresentation(e)} className="btn-filter button-bg btn-add-documents-catalogue btn-shape">
                        Añadir documentos seleccionados
                    </button>
            }
        </>
    )
}
export default ButtonForProductDocuments